import React, { useState, useEffect } from "react";

const extendedObjects = [
    "Apples", "Bananas", "Grapes", "Oranges", "Pencils", "Books", "Cars", "Balls", "Chocolates", 
    "Bottles", "Notebooks", "Pens", "Shoes", "Toys", "Mugs", "Cups", "Chairs", "Tables", "Laptops", 
    "Phones", "TV Sets", "Bags", "Hats", "Pizzas", "Cookies", "T-Shirts", "Jackets", "Socks", "Blankets", 
    "Gloves", "Plates", "Spoons", "Forks", "Knives", "Towels", "Rulers", "Erasers", "Markers", "Stamps", 
    "Backpacks", "Umbrellas", "Ice Creams", "Sandwiches", "Waffles", "Donuts", "Mice", "Keyboards", 
    "Bottles of Water", "Bicycles", "Trains", "Airplanes", "Tractors", "Blocks", "Stickers", "Cups of Tea", 
    "Cups of Coffee", "Flowers", "Trees", "Leaves", "Seeds", "Birds", "Fish", "Animals", "Stars", "Clouds", 
    "Sunflowers", "Cars", "Trucks", "Buses", "Motorcycles", "Teddies", "Lollipops", "Light Bulbs", "Paints", 
    "Paint Brushes", "Puzzles", "Tickets", "Cupcakes", "Candies", "Fruits", "Vegetables", "Spices", "Grains", 
    "Nuts", "Flowers", "Trees", "Flags", "Maps", "Pictures", "Plants", "Parrots", "Snakes", "Rabbits", 
    "Fish Tanks", "Aquarium Fish", "Jelly Beans", "Cans", "Bottles of Juice", "Fruits in a Basket", 
    "Basket of Eggs"
];

// Helper function to generate random tally marks
const generateTallyMarks = (num: number) => {
    const fullSets = Math.floor(num / 5);
    const remainder = num % 5;
    return "|||||   ".repeat(fullSets) + "|".repeat(remainder);
};

// Helper function to generate random counts for objects
const generateObjectData = () => {
    // Select 4 random objects
    const selectedObjects = extendedObjects.sort(() => 0.5 - Math.random()).slice(0, 4);

    return selectedObjects.map((object) => {
        const count = Math.floor(Math.random() * 20) + 1; // Random number between 1 and 20
        return {
            object,
            count,
            tally: generateTallyMarks(count),
        };
    });
};

// Generate dynamic questions
const generateQuestions = (data: any[]) => {
    const totalItems = data.reduce((sum, item) => sum + item.count, 0);
    const mostSoldObject = data.reduce((max, item) => (item.count > max.count ? item : max));
    const leastSoldObject = data.reduce((min, item) => (item.count < min.count ? item : min));
    const total = totalItems;

    return [
        { type: "count", question: `How many ${data[0]?.object} were counted?`, answer: data[0]?.count },
        { type: "count", question: `How many ${data[1]?.object} were counted?`, answer: data[1]?.count },
        { type: "comparison", question: `Which object was counted the most?`, answer: mostSoldObject.object },
        { type: "comparison", question: `Which object was counted the least?`, answer: leastSoldObject.object },
        { type: "total", question: `How many objects were counted in total?`, answer: total },
        {
            type: "addition",
            question: `What is the total count of ${data[0]?.object} and ${data[1]?.object}?`,
            answer: data[0]?.count + data[1]?.count,
        },
        {
            type: "multiplication",
            question: `What is the total count of ${data[0]?.object} if each is doubled?`,
            answer: data[0]?.count * 2,
        },
    ];
};

const TallyMarks: React.FC = () => {
    const [objectData, setObjectData] = useState<any[]>([]);
    const [questions, setQuestions] = useState<any[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
    const [userAnswer, setUserAnswer] = useState<string | number>("");
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    const generateQuestionSet = () => {
        const data = generateObjectData();
        setObjectData(data);
        setQuestions(generateQuestions(data));
        setCurrentQuestionIndex(Math.floor(Math.random() * 6) + 1);
        setUserAnswer("");
    }

    useEffect(() => {
        generateQuestionSet();
        document.title = "Mamas Guidance - Class Two - Mathematics - Data Handling - Tally Marks"; // Set page title
    }, []);

    const handleSubmit = () => {
        const currentQuestion = questions[currentQuestionIndex];
        
        if (
            userAnswer.toString().toLowerCase() === currentQuestion.answer.toString().toLowerCase()
        ) {
            setShowImage(true);
            setTimeout(() => {
                setUserAnswer("");
                generateQuestionSet();
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setShowImage(false);
            setError(true);
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserAnswer(event.target.value);
    };

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter additionWord">
                        <div className="tally-marks-worksheet">
                            <div className="mb-4">
                                <div className="text-center">
                                    <h5>The table shows the tally marks for the number of objects. Answer the questions below.</h5>
                                    <div>
                                        <table className="tally-table" style={{width: '100%'}}>
                                            <thead>
                                                <tr>
                                                    <th style={{fontSize: '20px'}}>Object</th>
                                                    <th style={{fontSize: '20px'}}>Tally Marks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {objectData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.object}</td>
                                                        <td className="tally-cell">{item.tally}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {questions.length > 0  && (
                            <div className="text-center mb-4">
                                <div>
                                    <h3 className="mb-4">{questions[currentQuestionIndex]?.question}</h3>
                                    <div className="center-my-text mt-2 mb-4 text-center">
                                        <input 
                                        type="text"
                                        value={userAnswer}
                                        onChange={handleChange}
                                            placeholder="?"
                                            className={`half-width form-control blank-input ${error == true  ? 'error' : ''} `}
                                            />
                                    </div>
                                </div>
                                    
                                <div className="center-my-text mt-2 text-center">
                                    <div className="half-width optionButton" onClick={handleSubmit}>
                                        Submit
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: '150px' }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                            alt="Well Done"
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default TallyMarks;
